import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'jft-revision-units-conversion',
    templateUrl: './revision-units-conversion.component.html',
    styleUrls: ['./revision-units-conversion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionUnitsConversionComponent implements OnInit {
    @Input() public currencies;
    @Input() public customUnits;
    @Input() public baseUnit;
    @Output() onSetUnitsDefault = new EventEmitter();
    @Output() onSetCustomUnit = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public setUnitsDefault(event) {
        this.onSetUnitsDefault.emit(event);
    }

    public onCustomUnit(event) {
        this.onSetCustomUnit.emit(event);
    }

}
